import React from 'react'
import {Close} from 'jbc-front/components/icons'
import Loading from 'components/Loading'
import {useMutation} from 'hooks/graphql'
import {dateFormat} from 'libs/formatter'
import {EmployeeDocumentContractRequest, CONFIRM_EMPLOYEE_DOCUMENT_CONTRACT_REQUEST} from '../../query'
import styles from './EmployeeDocumentContractRequestAsyncStatus.scss'

interface EmployeeDocumentContractRequestAsyncStatusProps {
  employeeId: number
  employeeDocumentContractRequest?: EmployeeDocumentContractRequest
}

export const EmployeeDocumentContractRequestAsyncStatus: React.FC<EmployeeDocumentContractRequestAsyncStatusProps> = ({
  employeeId,
  employeeDocumentContractRequest,
}) => {
  const [confirmEmployeeDocumentContractRequest] = useMutation(CONFIRM_EMPLOYEE_DOCUMENT_CONTRACT_REQUEST)

  if (!employeeDocumentContractRequest || employeeDocumentContractRequest.confirmed) {
    return null
  }

  const handleClose = async () => {
    await confirmEmployeeDocumentContractRequest({
      variables: {input: {id: employeeDocumentContractRequest.id, employeeId: employeeId}},
    })
  }

  switch (employeeDocumentContractRequest.status) {
    case 'waiting':
    case 'in_progress':
      return (
        <div className={styles.asyncStatusInProgress}>
          <div className={styles.asyncStatusInner}>
            <div className={styles.asyncStatusLoading}>
              <Loading />
            </div>
            <div className={styles.asyncStatusInfo}>
              <p className={styles.asyncStatusTitle}>電子契約の署名依頼を送信しています。</p>
              <div className={styles.asyncStatusDates}>
                <dl>
                  <dt>開始日時：</dt>
                  <dd>{dateFormat(employeeDocumentContractRequest.startedAt, 'LLL')}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      )
    case 'success':
      return (
        <div className={styles.asyncStatusSuccess}>
          <div className={styles.asyncStatusInner}>
            <div onClick={handleClose} className={styles.asyncStatusClose}>
              <Close size={20} />
            </div>
            <div className={styles.asyncStatusInfo}>
              <p className={styles.asyncStatusTitle}>
                電子契約の送信が完了しました。結果を「電子契約一覧」画面より確認してください。
              </p>
              <div className={styles.asyncStatusDates}>
                <dl>
                  <dt>開始日時：</dt>
                  <dd>{dateFormat(employeeDocumentContractRequest.startedAt, 'LLL')}</dd>
                </dl>
                <dl>
                  <dt>完了日時：</dt>
                  <dd>{dateFormat(employeeDocumentContractRequest.finishedAt, 'LLL')}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      )
    case 'failed':
      return (
        <div className={styles.asyncStatusError}>
          <div className={styles.asyncStatusErrorInner}>
            <div className={styles.asyncStatusInfo}>
              <p className={styles.asyncStatusTitle}>
                電子契約の送信にてエラーが発生しました。
                <br />
                送信先への署名依頼が送信されている可能性があります。送信状況をお調べしますので、サポート窓口までお問い合わせください。
              </p>
              <div className={styles.asyncStatusDates}>
                <dl>
                  <dt>開始日時：</dt>
                  <dd>{dateFormat(employeeDocumentContractRequest.startedAt, 'LLL')}</dd>
                </dl>
                <dl>
                  <dt>エラー日時：</dt>
                  <dd>{dateFormat(employeeDocumentContractRequest.finishedAt, 'LLL')}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      )
    default:
      return null
  }
}
